// extracted by mini-css-extract-plugin
export default {"dateTime":"DateTime_dateTime__Gagmo","time":"DateTime_time__vfQdg","date":"DateTime_date__JCAP-"};